/* eslint-disable */
import axios from '@/plugins/axios'
import io from "@/plugins/socket";
import store from '@/store'
import vue from 'vue'

io.on('USERS_ONLINE', data => store.commit('app/updateUsersOnline', data));
const uploadHeader = { headers: {'Content-Type': 'multipart/form-data'}};

const state = {
	auth: {
		email:null,
		password:null,
		hash:null,
		first_name:null,
		last_name:null,
		image:null
	},
	settings:{
		full:false
	},
	loading:true,
	loaders:{
		auth:false
	},
	errors:{},
	resolution:null,
	users:[],
	roles:[],
	directions:[],
	users_list:[],
	online:[],
	popup:{
		active:false,
		show:false,
		data:null,
		type:null
	}
}
const getters = {
	resolveUser: state => email => state.users.find(user => user.email === email),
	isOnline: state => email => state.online.some(m => m === email)
}


const actions = {
	async uploadFile({commit, rootState}, payload){
		try {
			const { data } = await axios.post('/app/upload', payload, uploadHeader);
			
			if( data.payload ) {
				$notify({ type:'success', message: 'upload_complete' });
				return data.payload
			}
			else $notify({ type:'error', message: data.error });
			
		}
		catch (e){ $notify({ type:'error', text: e }) }
	},
	async authCheckHash({ commit }, hash ){
		try {
			const { data } = await axios.post('/user/hash', { hash });
			
			if( data.payload ) commit('addAuthData', data.payload )
			else window.history.pushState({},'','restore?');
			
		}
		catch (e){ $notify({ type:'error', text: e})}
	},
	async getBasicData({ commit }){
		try {
			const { data } = await axios.get('/app/data')
			if( !data.payload ) $notify({ type:'error', text: data.error });
			else {
				const { users, roles, directions, online } = data.payload;
				if( users && roles && directions ) commit('setBasicData', { users, roles, directions,online })
				else $notify({ type:'error', text: 'Some data not recived..' });
			}
		}
		catch (e){ $notify({ type:'error', text: e }) }
		
	},
	async getUsersList({commit}, payload){
		try{
			const { data } = await axios.get('/app/users', { params:payload })
			if( !data.payload ) $notify({ type:'error', text: data.error });
			else commit('setUsersList', data.payload )
		}
		catch (e){ $notify({ type:'error', text: e }) }
	},
	async updateUser({commit},payload){
		try {
			const { data } = await axios.post('/app/user/update',payload)
			if( !data.payload ) $notify({ type:'error', text: data.error });
			else $notify({ type:'success', message: data.payload });
		}
		catch (e){ $notify({ type:'error', text: e }) }
	},
	async inviteUser({commit},payload){
		try {
			const { data } = await axios.post('/user/invite', payload)
			if( !data.payload ) $notify({ type:'error', text: data.error });
			else $notify({ type:'success', message: data.payload });
		}
		catch (e){ $notify({ type:'error', text: e }) }
	},
	async removeUser({commit},payload){
		try {
			const { data } = await axios.post('/app/user/delete',payload)
			if( !data.payload ) $notify({ type:'error', text: data.error });
			else $notify({ type:'success', message: data.payload });
		}
		catch (e){ $notify({ type:'error', text: e }) }
	},
	toggleEditUser({ commit }, payload){
	
	},
	setAuthData({ commit }, payload ){
		commit('setAuthData', payload)
	},
	setLoading({commit}, state){
		commit('setLoading', state)
	},
	setLoaders({commit}, payload){
		commit('setLoaders', payload)
	},
	setSettings({commit},payload){
		commit('setSettings', payload)
	},
	togglePopup({commit},payload){
		
		commit('togglePopup', payload)
	},
	setPopupValue({commit}, payload){
		commit('setPopupValue', payload)
	}
}

const mutations = {
	
	setLoading(state, payload){
		state.loading = payload
	},
	setAuthData(state, payload){
		state.auth[ payload.name ] = payload.value
	},
	addAuthData(state, payload){
		state.auth = Object.assign(state.auth, payload)
	},
	setLoading(state,payload){
		state.loading = payload
	},
	setSettings(state,payload){
		state.settings = Object.assign(state.settings, payload)
	},
	setUsersList(state,payload){
		state.users_list = payload
	},
	setLoaders(state, payload){
		state.loaders[ payload.type ] = payload.state
	},
	setBasicData(state,payload){
		const { users, directions, roles, online } = payload;
		state.users = users
		state.roles = roles
		state.directions = directions
		state.online = online || []
	},
	togglePopup(state, payload){
		
		if( payload.data ){
			state.popup = { active: true, data:payload.data, type: payload.type }
			setTimeout(() => state.popup = { show:true, active: true, data:payload.data, type: payload.type }, 200)
		}
		else {
			state.popup = Object.assign(state.popup, { show: false })
			setTimeout(() => state.popup = { active: false, show: false, data:null, type:null }, 400)
		}
	},
	setPopupValue(state,payload){
		const { name, value } = payload;
		state.popup.data[ name ] = value
	},
	updateUsersOnline(state,data){
		state.online = data
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}